import {
  FETCH_RECORDS,
  FETCH_RECORDS_SUCCESS,
  FETCH_RECORDS_FAIL,
  WAIT,
  WAIT_SUCCESS,
  WAIT_FAIL
} from "./types";
import {
  delRequest,
  getRequest,
  postRequest,
  putRequest
} from "../../../core/network";
import endpoints from "../../../constants/endPoints.json";
import { notification } from "antd";
import download from "downloadjs";

export const getDashboard = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: FETCH_RECORDS });
  const token = useState().auth?.token;

  getRequest(data, undefined, token, endpoints.imsWarehouseStaff.dashboard)
    .then((response) => {
      const { data } = response;
      return dispatch({
        type: FETCH_RECORDS_SUCCESS,
        payload: data
      });
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message,
      });
      console.log(err);
      return dispatch({
        type: FETCH_RECORDS_FAIL
      });
    });
};

export const getVendorDashboard = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: FETCH_RECORDS });
  const token = useState().auth?.token;

  getRequest(data, undefined, token, endpoints.imsWarehouseStaff.vendorDashboard)
    .then((response) => {
      const { data } = response;
      return dispatch({
        type: FETCH_RECORDS_SUCCESS,
        payload: data
      });
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message,
      });
      console.log(err);
      return dispatch({
        type: FETCH_RECORDS_FAIL
      });
    });
};

export const getProducts = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: FETCH_RECORDS });
  const token = useState().auth?.token;

  getRequest(data, undefined, token, endpoints.imsWarehouseStaff.products)
    .then((response) => {
      const { data } = response;
      return dispatch({
        type: FETCH_RECORDS_SUCCESS,
        payload: data
      });
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message,
      });
      console.log(err);
      return dispatch({
        type: FETCH_RECORDS_FAIL
      });
    });
};

export const downloadInboundsQRS = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: WAIT });
  const token = useState().auth?.token;

  postRequest(data, { responseType: "arraybuffer" }, undefined, token, endpoints.imsWarehouseStaff.inbounds.print)
    .then((response) => {
      download(response.data, response.headers["filename"], "application/pdf")
      return dispatch({
        type: WAIT_SUCCESS
      });
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message,
      });
      console.log(err);
      return dispatch({
        type: WAIT_FAIL
      });
    });
};

export const downloadStockQRS = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: WAIT });
  const token = useState().auth?.token;

  getRequest({ ...data, responseType: "arraybuffer" }, undefined, token, endpoints.imsWarehouseStaff.stocksDownload)
    .then((response) => {
      download(response.data, response.headers["filename"], "application/pdf")
      return dispatch({
        type: WAIT_SUCCESS
      });
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message,
      });
      console.log(err);
      return dispatch({
        type: WAIT_FAIL
      });
    });
};

export const downloadProductsQRS = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: WAIT });
  const token = useState().auth?.token;

  postRequest(data, { responseType: "arraybuffer" }, undefined, token, endpoints.imsWarehouseStaff.productsDownload)
    .then((response) => {
      download(response.data, response.headers["filename"], "application/pdf")
      return dispatch({
        type: WAIT_SUCCESS
      });
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message,
      });
      console.log(err);
      return dispatch({
        type: WAIT_FAIL
      });
    });
};

export const addOutbound = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: WAIT });
  const token = useState().auth?.token;
  notification.info({ message: "Creating Outbound...",})
  postRequest(data, undefined, undefined, token, endpoints.imsWarehouseStaff.inbounds.outbounds)
    .then((response) => {
      const { data } = response;
      notification.success({
        message: data?.message,
      });
      dispatch({
        type: WAIT_SUCCESS
      });
      if (navigate && data?.taskId) {
        navigate(`/ims/warehouse-staff/item-updates/${data.taskId}`);
      } else if (navigate && data?.outbound?._id) {
        navigate(`/ims/warehouse-staff/outbounds/success/${data.outbound._id}`, { state: { outbound: data.outbound } });
      } else if (navigate) {
        navigate("/ims/warehouse-staff");
      }
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message,
      });
      console.log(err);
      return dispatch({
        type: WAIT_FAIL
      });
    });
};

export const getOutbound = (outboundId) => (dispatch, useState) => {
  dispatch({ type: FETCH_RECORDS });
  const token = useState().auth?.token;

  getRequest(undefined, `/${outboundId}`, token, endpoints.imsWarehouseStaff.inbounds.outbounds)
    .then((response) => {
      const { data } = response;
      return dispatch({
        type: FETCH_RECORDS_SUCCESS,
        payload: data
      });
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message,
      });
      console.log(err);
      return dispatch({
        type: FETCH_RECORDS_FAIL
      });
    });
};

export const downloadOutboundReceipt = (outboundId) => (dispatch, useState) => {
  dispatch({ type: WAIT });
  const token = useState().auth?.token;

  getRequest({ responseType: "arraybuffer" }, `/${outboundId}/pdf`, token, endpoints.imsWarehouseStaff.inbounds.outbounds)
    .then((response) => {
      download(response.data, response.headers["filename"], "application/pdf");
      return dispatch({
        type: WAIT_SUCCESS
      });
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message,
      });
      console.log(err);
      return dispatch({
        type: WAIT_FAIL
      });
    });
};

export const receiveInbound = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: WAIT });
  const token = useState().auth?.token;

  putRequest(data, undefined, undefined, token, endpoints.imsWarehouseStaff.inbounds.items)
    .then((response) => {
      const { data } = response;
      notification.success({
        message: data?.message,
      });
      dispatch({
        type: WAIT_SUCCESS
      });
      if (navigate && data?.taskId) {
        navigate(`/ims/warehouse-staff/item-updates/${data.taskId}`);
      } else if (navigate) {
        navigate("/ims/warehouse-staff/inbounds");
      }
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message,
      });
      console.log(err);
      return dispatch({
        type: WAIT_FAIL
      });
    });
};

export const getItemUpdateTask = (taskId) => (dispatch, useState) => {
  const token = useState().auth?.token;
  return getRequest(undefined, `/${taskId}`, token, endpoints.imsWarehouseStaff.itemUpdates)
    .then((response) => response.data.task);
};

export const getItemUpdateTasks = (data) => (dispatch, useState) => {
  dispatch({ type: FETCH_RECORDS });
  const token = useState().auth?.token;
  return getRequest(data, undefined, token, endpoints.imsWarehouseStaff.itemUpdates)
    .then((response) => {
      dispatch({
        type: FETCH_RECORDS_SUCCESS,
        payload: { itemUpdateTasks: response.data.itemUpdates },
      });
      return response.data.itemUpdates;
    })
    .catch((err) => {
      notification.error({ message: err?.response?.data?.message });
      dispatch({ type: FETCH_RECORDS_FAIL });
      throw err;
    });
};

export const downloadInboundChecklist = (prRef) => (dispatch, useState) => {
  dispatch({ type: WAIT });
  const token = useState().auth?.token;
  return getRequest({ prRef, responseType: "arraybuffer" }, undefined, token, endpoints.imsWarehouseStaff.inbounds.checklist)
    .then((response) => {
      download(response.data, response.headers["filename"] || "checklist.pdf", "application/pdf");
      dispatch({ type: WAIT_SUCCESS });
    })
    .catch((err) => {
      notification.error({ message: err?.response?.data?.message || "Download failed" });
      dispatch({ type: WAIT_FAIL });
    });
};

export const downloadInboundReceipt = ({ prRef, inboundId }) => (dispatch, useState) => {
  dispatch({ type: WAIT });
  const token = useState().auth?.token;
  const query = { responseType: "arraybuffer", ...(prRef ? { prRef } : { inboundId }) };
  return getRequest(query, undefined, token, endpoints.imsWarehouseStaff.inbounds.receipt)
    .then((response) => {
      download(response.data, response.headers["filename"] || "receipt.pdf", "application/pdf");
      dispatch({ type: WAIT_SUCCESS });
    })
    .catch((err) => {
      notification.error({ message: err?.response?.data?.message || "Download failed" });
      dispatch({ type: WAIT_FAIL });
    });
};

export const getWarehouses = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: FETCH_RECORDS });
  const token = useState().auth?.token;

  getRequest(data, undefined, token, endpoints.imsWarehouseStaff.warehouses)
    .then((response) => {
      const { data } = response;
      return dispatch({
        type: FETCH_RECORDS_SUCCESS,
        payload: data
      });
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message,
      });
      console.log(err);
      return dispatch({
        type: FETCH_RECORDS_FAIL
      });
    });
};

export const getLocations = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: FETCH_RECORDS });
  const token = useState().auth?.token;

  getRequest(data, undefined, token, endpoints.imsWarehouseStaff.locations)
    .then((response) => {
      const { data } = response;
      return dispatch({
        type: FETCH_RECORDS_SUCCESS,
        payload: data
      });
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message,
      });
      console.log(err);
      return dispatch({
        type: FETCH_RECORDS_FAIL
      });
    });
};

export const addLocations = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: FETCH_RECORDS });
  const token = useState().auth?.token;

  postRequest(data, undefined, undefined, token, endpoints.imsWarehouseStaff.locations)
    .then((response) => {
      const { data } = response;
      dispatch({
        type: FETCH_RECORDS_SUCCESS,
        payload: data
      });
      navigate && navigate("/ims/admin/warehouses");
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message,
      });
      console.log(err);
      return dispatch({
        type: FETCH_RECORDS_FAIL
      });
    });
};

export const editLocations = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: FETCH_RECORDS });
  const token = useState().auth?.token;

  putRequest(data, undefined, undefined, token, endpoints.imsWarehouseStaff.locations)
    .then((response) => {
      const { data } = response;
      return dispatch({
        type: FETCH_RECORDS_SUCCESS,
        payload: data
      });
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message,
      });
      console.log(err);
      return dispatch({
        type: FETCH_RECORDS_FAIL
      });
    });
};

export const deleteLocations = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: FETCH_RECORDS });
  const token = useState().auth?.token;

  delRequest(data, undefined, token, endpoints.imsWarehouseStaff.locations)
    .then((response) => {
      const { data } = response;
      return dispatch({
        type: FETCH_RECORDS_SUCCESS,
        payload: data
      });
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message,
      });
      console.log(err);
      return dispatch({
        type: FETCH_RECORDS_FAIL
      });
    });
};

export const getStocks = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: FETCH_RECORDS });
  const token = useState().auth?.token;

  getRequest(data, undefined, token, endpoints.imsWarehouseStaff.stocks)
    .then((response) => {
      const { data } = response;
      return dispatch({
        type: FETCH_RECORDS_SUCCESS,
        payload: data
      });
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message,
      });
      console.log(err);
      return dispatch({
        type: FETCH_RECORDS_FAIL
      });
    });
};

export const addStocks = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: FETCH_RECORDS });
  const token = useState().auth?.token;

  postRequest(data, undefined, undefined, token, endpoints.imsWarehouseStaff.stocks)
    .then((response) => {
      const { data } = response;
      return dispatch({
        type: FETCH_RECORDS_SUCCESS,
        payload: data
      });
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message,
      });
      console.log(err);
      return dispatch({
        type: FETCH_RECORDS_FAIL
      });
    });
};

export const editStocks = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: FETCH_RECORDS });
  const token = useState().auth?.token;

  putRequest(data, undefined, undefined, token, endpoints.imsWarehouseStaff.stocks)
    .then((response) => {
      const { data } = response;
      return dispatch({
        type: FETCH_RECORDS_SUCCESS,
        payload: data
      });
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message,
      });
      console.log(err);
      return dispatch({
        type: FETCH_RECORDS_FAIL
      });
    });
};

export const deleteStocks = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: FETCH_RECORDS });
  const token = useState().auth?.token;

  delRequest(data, undefined, token, endpoints.imsWarehouseStaff.stocks)
    .then((response) => {
      const { data } = response;
      return dispatch({
        type: FETCH_RECORDS_SUCCESS,
        payload: data
      });
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message,
      });
      console.log(err);
      return dispatch({
        type: FETCH_RECORDS_FAIL
      });
    });
};

export const getOrders = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: FETCH_RECORDS });
  const token = useState().auth?.token;

  getRequest(data, undefined, token, endpoints.imsWarehouseStaff.orders)
    .then((response) => {
      const { data } = response;
      return dispatch({
        type: FETCH_RECORDS_SUCCESS,
        payload: data
      });
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message,
      });
      console.log(err);
      return dispatch({
        type: FETCH_RECORDS_FAIL
      });
    });
};

export const addOrders = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: FETCH_RECORDS });
  const token = useState().auth?.token;

  postRequest(data, undefined, undefined, token, endpoints.imsWarehouseStaff.orders)
    .then((response) => {
      const { data } = response;
      dispatch({
        type: FETCH_RECORDS_SUCCESS,
        payload: data
      });
      navigate && navigate("/ims/admin/orders");
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message,
      });
      console.log(err);
      return dispatch({
        type: FETCH_RECORDS_FAIL
      });
    });
};

export const editOrders = (data, setAction, action) => (dispatch, useState) => {
  dispatch({ type: FETCH_RECORDS });
  const token = useState().auth?.token;

  putRequest(data, undefined, undefined, token, endpoints.imsWarehouseStaff.orders)
    .then((response) => {
      const { data } = response;
      setAction && setAction(!action)
      return dispatch({
        type: FETCH_RECORDS_SUCCESS,
        payload: data
      });
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message,
      });
      console.log(err);
      return dispatch({
        type: FETCH_RECORDS_FAIL
      });
    });
};

export const recreateOrder = (data, setAction, action) => (dispatch, useState) => {
  dispatch({ type: FETCH_RECORDS });
  const token = useState().auth?.token;

  getRequest(data, undefined, token, endpoints.imsWarehouseStaff.recreateOrders)
    .then((response) => {
      const { data } = response;
      notification.success({
        message: data?.message,
      });
      setAction && setAction(!action)
      return dispatch({
        type: FETCH_RECORDS_SUCCESS,
        payload: data
      });
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message,
      });
      console.log(err);
      return dispatch({
        type: FETCH_RECORDS_FAIL
      });
    });
};

export const resetOrder = (data, setAction, action) => (dispatch, useState) => {
  dispatch({ type: FETCH_RECORDS });
  const token = useState().auth?.token;

  getRequest(data, undefined, token, endpoints.imsWarehouseStaff.resetOrders)
    .then((response) => {
      const { data } = response;
      notification.success({
        message: data?.message,
      });
      setAction && setAction(!action)
      return dispatch({
        type: FETCH_RECORDS_SUCCESS,
        payload: data
      });
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message,
      });
      console.log(err);
      return dispatch({
        type: FETCH_RECORDS_FAIL
      });
    });
};

export const silentCancelOrder = (data, onComplete) => (dispatch, useState) => {
  dispatch({ type: FETCH_RECORDS });
  const token = useState().auth?.token;

  getRequest(data, undefined, token, endpoints.imsWarehouseStaff.silentCancelOrder)
    .then((response) => {
      const { data } = response;
      notification.success({
        message: data?.message,
      });
      if (typeof onComplete === "function") {
        onComplete(true);
      }
      return dispatch({
        type: FETCH_RECORDS_SUCCESS,
        payload: data
      });
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message,
      });
      console.log(err);
      if (typeof onComplete === "function") {
        onComplete(false);
      }
      return dispatch({
        type: FETCH_RECORDS_FAIL
      });
    });
};

export const setItemSoldOut = (data, setAction, action) => (dispatch, useState) => {
  dispatch({ type: WAIT });
  const token = useState().auth?.token;

  putRequest(data, undefined, undefined, token, endpoints.imsWarehouseStaff.soldOutOrders)
    .then((response) => {
      const { data } = response;
      notification.success({
        message: data.message,
      })
      return dispatch({
        type: WAIT_SUCCESS
      });
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message,
      });
      console.log(err);
      return dispatch({
        type: WAIT_FAIL
      });
    });
};

export const setOrderReturnedToChainz = (data, setAction, action) => (dispatch, useState) => {
  dispatch({ type: WAIT });
  const token = useState().auth?.token;

  putRequest(data, undefined, undefined, token, endpoints.imsWarehouseStaff.returnedToChainzOrders)
    .then((response) => {
      const { data } = response;
      notification.success({
        message: data.message,
      })
      return dispatch({
        type: WAIT_SUCCESS
      });
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message,
      });
      console.log(err);
      return dispatch({
        type: WAIT_FAIL
      });
    });
};

export const deleteOrders = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: FETCH_RECORDS });
  const token = useState().auth?.token;

  delRequest(data, undefined, token, endpoints.imsWarehouseStaff.orders)
    .then((response) => {
      const { data } = response;
      return dispatch({
        type: FETCH_RECORDS_SUCCESS,
        payload: data
      });
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message,
      });
      console.log(err);
      return dispatch({
        type: FETCH_RECORDS_FAIL
      });
    });
};

export const getEmployees = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: FETCH_RECORDS });
  const token = useState().auth?.token;

  getRequest(data, undefined, token, endpoints.imsWarehouseStaff.employees)
    .then((response) => {
      const { data } = response;
      return dispatch({
        type: FETCH_RECORDS_SUCCESS,
        payload: data
      });
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message,
      });
      console.log(err);
      return dispatch({
        type: FETCH_RECORDS_FAIL
      });
    });
};

export const addEmployees = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: FETCH_RECORDS });
  const token = useState().auth?.token;

  postRequest(data, undefined, undefined, token, endpoints.imsWarehouseStaff.employees)
    .then((response) => {
      const { data } = response;
      dispatch({
        type: FETCH_RECORDS_SUCCESS,
        payload: data
      });
      navigate && navigate("/ims/admin/employees");
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message,
      });
      console.log(err);
      return dispatch({
        type: FETCH_RECORDS_FAIL
      });
    });
};

export const editEmployees = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: FETCH_RECORDS });
  const token = useState().auth?.token;

  putRequest(data, undefined, undefined, token, endpoints.imsWarehouseStaff.employees)
    .then((response) => {
      const { data } = response;
      return dispatch({
        type: FETCH_RECORDS_SUCCESS,
        payload: data
      });
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message,
      });
      console.log(err);
      return dispatch({
        type: FETCH_RECORDS_FAIL
      });
    });
};

export const deleteEmployees = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: FETCH_RECORDS });
  const token = useState().auth?.token;

  delRequest(data, undefined, token, endpoints.imsWarehouseStaff.employees)
    .then((response) => {
      const { data } = response;
      return dispatch({
        type: FETCH_RECORDS_SUCCESS,
        payload: data
      });
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message,
      });
      console.log(err);
      return dispatch({
        type: FETCH_RECORDS_FAIL
      });
    });
};

export const getVendors = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: FETCH_RECORDS });
  const token = useState().auth?.token;

  getRequest(data, undefined, token, endpoints.imsWarehouseStaff.vendors)
    .then((response) => {
      const { data } = response;
      return dispatch({
        type: FETCH_RECORDS_SUCCESS,
        payload: data
      });
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message,
      });
      console.log(err);
      return dispatch({
        type: FETCH_RECORDS_FAIL
      });
    });
};

export const getPartners = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: FETCH_RECORDS });
  const token = useState().auth?.token;

  getRequest(data, undefined, token, endpoints.imsWarehouseStaff.partners)
    .then((response) => {
      const { data } = response;
      return dispatch({
        type: FETCH_RECORDS_SUCCESS,
        payload: data
      });
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message,
      });
      console.log(err);
      return dispatch({
        type: FETCH_RECORDS_FAIL
      });
    });
};

export const getNoShippingOrders = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: FETCH_RECORDS });
  const token = useState().auth?.token;

  getRequest(data, undefined, token, endpoints.imsWarehouseStaff.actionCenter.noShipping)
    .then((response) => {
      const { data } = response;
      return dispatch({
        type: FETCH_RECORDS_SUCCESS,
        payload: data
      });
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message,
      });
      console.log(err);
      return dispatch({
        type: FETCH_RECORDS_FAIL
      });
    });
};

export const getLateFulfillmentOrders = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: FETCH_RECORDS });
  const token = useState().auth?.token;

  getRequest(data, undefined, token, endpoints.imsWarehouseStaff.actionCenter.lateFulfillment)
    .then((response) => {
      const { data } = response;
      return dispatch({
        type: FETCH_RECORDS_SUCCESS,
        payload: data
      });
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message,
      });
      console.log(err);
      return dispatch({
        type: FETCH_RECORDS_FAIL
      });
    });
};

export const getLateDeliveryOrders = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: FETCH_RECORDS });
  const token = useState().auth?.token;

  getRequest(data, undefined, token, endpoints.imsWarehouseStaff.actionCenter.lateDelivery)
    .then((response) => {
      const { data } = response;
      return dispatch({
        type: FETCH_RECORDS_SUCCESS,
        payload: data
      });
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message,
      });
      console.log(err);
      return dispatch({
        type: FETCH_RECORDS_FAIL
      });
    });
};

export const getLateReturnsOrders = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: FETCH_RECORDS });
  const token = useState().auth?.token;

  getRequest(data, undefined, token, endpoints.imsWarehouseStaff.actionCenter.lateReturns)
    .then((response) => {
      const { data } = response;
      return dispatch({
        type: FETCH_RECORDS_SUCCESS,
        payload: data
      });
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message,
      });
      console.log(err);
      return dispatch({
        type: FETCH_RECORDS_FAIL
      });
    });
};

export const getLatePickupOrders = (data, navigate) => (dispatch, useState) => {
  dispatch({ type: FETCH_RECORDS });
  const token = useState().auth?.token;

  getRequest(data, undefined, token, endpoints.imsWarehouseStaff.actionCenter.latePickup)
    .then((response) => {
      const { data } = response;
      return dispatch({
        type: FETCH_RECORDS_SUCCESS,
        payload: data
      });
    })
    .catch((err) => {
      notification.error({
        message: err?.response?.data?.message,
      });
      console.log(err);
      return dispatch({
        type: FETCH_RECORDS_FAIL
      });
    });
};